import keys from '@debbie/common/dist/cache/keys.js';
import { getCollectorOnCase } from '@debbie/common/dist/cases/index.js';
import { courts } from '@debbie/common/dist/court/index.js';
import { getContactPerson } from '@debbie/common/dist/customers/index.js';
import { Entity, addressToString } from '@debbie/common/dist/index.js';
import { Direction, InteractionType, OutgoingState, } from '@debbie/common/dist/interactions/index.js';
import { TemplateType } from '@debbie/common/dist/templates/index.js';
import { getMentionSuggestions, toEditorMentions, } from '@debbie/common/dist/templates/suggestions.js';
import { TribunalCaseType } from '@debbie/common/dist/tribunal/cases/types.js';
import { DKTribunalJobType } from '@debbie/common/dist/tribunal/jobs/countries/denmark.js';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { useCase } from '@debbie/cortex/dist/cases/index.js';
import { useCollector } from '@debbie/cortex/dist/collectors/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { useCustomer } from '@debbie/cortex/dist/customers/index.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
import { useEmailServer } from '@debbie/cortex/dist/email-servers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTemplatesMap } from '@debbie/cortex/dist/templates/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import { tribunalJobsEntity } from '@debbie/cortex/dist/tribunal/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { encodeText, getSubjectContent, parseText, } from '../../../../utils/templates.js';
import { DocumentsPicker } from '../../../documents/index.js';
import NewEditor from '../../../editor/Editor.js';
import { useEditorState } from '../../../editor/hooks.js';
import { htmlToPlainText } from '../../../editor/utils.js';
import { Button, Checkbox, Modal, SearchInput, } from '../../../index.js';
import { TemplateSearch } from '../../../interactions/index.js';
import { PDFTemplatePreviewModal } from '../../../interactions/PDFTemplatePreview.js';
import PreviewInteraction from '../../../interactions/PreviewInteraction.js';
const AndreFogedsager = (props) => {
    const lang = useSelector((s) => s.lang);
    const singleCaseLoader = useCase(props.caseId);
    const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null;
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const collectorId = singleCase &&
        creditor &&
        getCollectorOnCase(singleCase.type, singleCase.collectorId, creditor.identityCollectorId, creditor.defaultCollectorId);
    const collectorLoadable = useCollector(collectorId || undefined);
    const collector = h.hasData(collectorLoadable) ? collectorLoadable.data : null;
    const emailServerLoadable = useEmailServer(collector?.emailServerId);
    const emailServer = h.hasData(emailServerLoadable)
        ? emailServerLoadable.data
        : null;
    const tenant = useTenant();
    const customerLoader = useCustomer(singleCase?.customerId);
    const customer = h.hasData(customerLoader) ? customerLoader.data : null;
    const templatesMapLoadable = useTemplatesMap();
    const templatesMap = h.hasData(templatesMapLoadable)
        ? templatesMapLoadable.data
        : {};
    const documentsLoadable = useDocumentsByReference(singleCase?.caseId);
    const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null;
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? propertyTypesLoadable.data
        : undefined;
    const mentionSuggestions = getMentionSuggestions(lang, TemplateType.EMAIL, propertyTypes || undefined, tenant);
    const [loading, setLoading] = useState(false);
    const [emailTemplateId, setEmailTemplateId] = useState(null);
    const emailSubjectState = useEditorState();
    const emailBodyState = useEditorState();
    const [emailPreviewModalOpen, setEmailPreviewModalOpen] = useState(false);
    const [emailAttachmentTemplateId, setEmailAttachmentTemplateId] = useState(null);
    const emailAttachmentState = useEditorState();
    const [emailAttachmentPreviewModalOpen, setEmailAttachmentPreviewModalOpen] = useState(false);
    const [selectedDocuments, setSelectedDocuments] = useState([]);
    const contactPerson = customer && singleCase && getContactPerson(customer, singleCase);
    const [court, setCourt] = useState();
    const [attachDocument, _setAttachDocument] = useState(false);
    const setAttachDocument = (attach) => {
        _setAttachDocument(attach);
        localStorage.setItem('fogedrekvisitionAttachDocument', attach ? '1' : '0');
    };
    useEffect(() => {
        const attach = localStorage.getItem('fogedrekvisitionAttachDocument');
        if (attach === '1') {
            _setAttachDocument(true);
        }
    }, []);
    const defaultsLoadedRef = React.useRef(false);
    useEffect(() => {
        if (defaultsLoadedRef.current) {
            return;
        }
        if (tenant && creditor && h.hasData(templatesMapLoadable)) {
            defaultsLoadedRef.current = true;
            const tenantEmailTempalteId = tenant?.settings?.tribunal?.caseTypes &&
                tenant?.settings?.tribunal?.caseTypes[TribunalCaseType.DKAndreFogedsager]?.defaultEmailTemplateId;
            const creditorEmailTempalteId = creditor?.settings?.tribunal?.caseTypes &&
                creditor.settings.tribunal.caseTypes[TribunalCaseType.DKAndreFogedsager]
                    ?.defaultEmailTemplateId;
            const emailTemplateId = creditorEmailTempalteId || tenantEmailTempalteId;
            if (emailTemplateId) {
                const emailTemplate = templatesMap[emailTemplateId];
                if (emailTemplate) {
                    setEmailTemplateId(emailTemplateId);
                    if (emailTemplate.subject) {
                        emailSubjectState.overwriteEditorContent(encodeText(emailTemplate.subject, mentionSuggestions));
                    }
                    emailBodyState.overwriteEditorContent(encodeText(emailTemplate.html, mentionSuggestions));
                }
            }
            const tenantEmailAttachmentTempalteId = tenant?.settings?.tribunal?.caseTypes &&
                tenant.settings.tribunal.caseTypes[TribunalCaseType.DKAndreFogedsager]
                    ?.defaultEmailAttachmentTemplateId;
            const creditorEmailAttachmentTempalteId = creditor?.settings?.tribunal?.caseTypes &&
                creditor.settings.tribunal.caseTypes[TribunalCaseType.DKAndreFogedsager]
                    ?.defaultEmailAttachmentTemplateId;
            const emailAttachmentTemplateId = creditorEmailAttachmentTempalteId || tenantEmailAttachmentTempalteId;
            if (emailAttachmentTemplateId) {
                const attachmentTemplate = templatesMap[emailAttachmentTemplateId];
                if (attachmentTemplate) {
                    setEmailAttachmentTemplateId(emailAttachmentTemplateId);
                    emailAttachmentState.overwriteEditorContent(encodeText(attachmentTemplate.html, mentionSuggestions));
                    _setAttachDocument(true);
                }
            }
        }
    }, [creditor, tenant, templatesMap]);
    const getCourt = () => {
        if (court || court === null) {
            return court;
        }
        const _court = contactPerson &&
            contactPerson.details.courtId &&
            courts.find((c) => contactPerson.details.courtId &&
                [c.id, c.courtId].includes(contactPerson.details.courtId));
        if (_court) {
            return _court;
        }
    };
    const createTribunalCase = async () => {
        setLoading(true);
        try {
            if (singleCase) {
                await tribunalAPI.createTribunalJob({
                    type: DKTribunalJobType.CreateOtherFogedsager,
                    data: {
                        courtId: getCourt().courtId,
                        fileIds: selectedDocuments.map((d) => d.fileId),
                        emailSubject: getSubjectContent(htmlToPlainText(parseText(emailSubjectState.html, mentionSuggestions))),
                        emailBody: htmlToPlainText(parseText(emailBodyState.html, mentionSuggestions)),
                        emailHTML: parseText(emailBodyState.html, mentionSuggestions),
                        emailTemplateAttachments: attachDocument && emailAttachmentTemplateId
                            ? [
                                {
                                    templateId: emailAttachmentTemplateId,
                                    fileName: (templatesMap[emailAttachmentTemplateId] &&
                                        templatesMap[emailAttachmentTemplateId].fileName) ||
                                        null,
                                    content: parseText(emailAttachmentState.html, mentionSuggestions),
                                },
                            ]
                            : undefined,
                    },
                    caseId: singleCase.caseId,
                });
                q.invalidate(keys.write.create(tribunalJobsEntity));
                props.onCreated && props.onCreated();
            }
        }
        catch (err) {
            console.error(err);
        }
        setLoading(false);
    };
    return (React.createElement("div", null,
        React.createElement("h3", null, lang.tribunal.jurisdiction),
        React.createElement(SearchInput, { placeholder: lang.documents.selectCourt, searchAll: (q) => {
                return courts
                    .filter((c) => `${c.name}${c.address}${c.city}${c.email}${c.phone}`
                    .toLowerCase()
                    .indexOf(q.toLowerCase()) !== -1)
                    .map((c) => ({
                    key: c.id,
                    heading: c.name,
                    subheading: addressToString(c),
                    returnData: c,
                }));
            }, static: getCourt() && getCourt().name, onRemoveStatic: () => {
                setCourt({
                    court: null,
                });
            }, onSelect: (court) => {
                setCourt({
                    ...court,
                });
            }, searchDelay: 0, forceOpen: true }),
        React.createElement("h3", null, "Tekst i e-mail"),
        singleCase && customer && (React.createElement(TemplateSearch, { case: singleCase, customer: customer, templateType: TemplateType.EMAIL, onChange: (content, subject, templateId) => {
                emailBodyState.overwriteEditorContent(content);
                setEmailTemplateId(templateId);
                if (subject) {
                    emailSubjectState.overwriteEditorContent(subject);
                }
            } })),
        React.createElement(NewEditor, { hideControls: true, compact: true, singleLine: true, placeholder: lang.interactions.subject, initialContent: emailSubjectState.editorContent, mentions: toEditorMentions(mentionSuggestions), onChange: emailSubjectState.onChange }),
        React.createElement("br", null),
        React.createElement(NewEditor, { mentions: toEditorMentions(mentionSuggestions), onChange: emailBodyState.onChange, initialContent: emailBodyState.editorContent }),
        React.createElement("br", null),
        React.createElement(Button, { onClick: () => setEmailPreviewModalOpen(true), size: "small", theme: "secondary" }, "Forh\u00E5ndsvisning"),
        React.createElement("br", null),
        emailPreviewModalOpen && (React.createElement(Modal, { onToggle: () => setEmailPreviewModalOpen(!emailPreviewModalOpen), header: lang.interactions.preview }, emailServer && singleCase && (React.createElement(PreviewInteraction, { interaction: {
                templateId: emailTemplateId || null,
                direction: Direction.OUTGOING,
                state: OutgoingState.SENT,
                type: InteractionType.Email,
                attachments: [],
                referenceId: singleCase.caseId,
                referenceType: Entity.Case,
                details: {
                    server: emailServer.id,
                    subject: getSubjectContent(htmlToPlainText(parseText(emailSubjectState.html, mentionSuggestions))),
                    from: `${emailServer.fromName} <${emailServer.fromEmail}>`,
                    replyTo: collector?.replyTo,
                    body: parseText(emailBodyState.html, mentionSuggestions),
                    html: parseText(emailBodyState.html, mentionSuggestions),
                    to: court?.emailFogedretIndleveringFogedrekvisition ||
                        'info@example.com',
                },
                minVisibilityRole: 'client',
            } })))),
        React.createElement("br", null),
        React.createElement(Checkbox, { placeholder: "Tilf\u00F8j en brevskabelon som vedh\u00E6ftning til e-mailen", checked: attachDocument, onChange: (e) => setAttachDocument(e.target.checked) }),
        attachDocument && (React.createElement("div", null,
            singleCase && customer && (React.createElement(TemplateSearch, { case: singleCase, customer: customer, templateType: TemplateType.LETTER, onChange: (content, subject, templateId) => {
                    console.log(content, subject, templateId);
                    setEmailAttachmentTemplateId(templateId);
                    emailAttachmentState.overwriteEditorContent(content);
                } })),
            emailAttachmentTemplateId && singleCase && (React.createElement(React.Fragment, null,
                React.createElement(NewEditor, { mentions: toEditorMentions(mentionSuggestions), onChange: emailAttachmentState.onChange, initialContent: emailAttachmentState.editorContent }),
                React.createElement("br", null),
                React.createElement(Button, { onClick: () => setEmailAttachmentPreviewModalOpen(true), size: "small", theme: "secondary" }, "Forh\u00E5ndsvisning"),
                emailAttachmentPreviewModalOpen && (React.createElement(PDFTemplatePreviewModal, { caseId: singleCase.caseId, templateId: emailAttachmentTemplateId, body: parseText(emailAttachmentState.html, mentionSuggestions), onToggle: () => setEmailAttachmentPreviewModalOpen(!emailAttachmentPreviewModalOpen) })))))),
        React.createElement("br", null),
        singleCase && documents && documents.length > 0 && (React.createElement(DocumentsPicker, { documents: documents, onChange: (docs) => setSelectedDocuments(docs), caseId: singleCase.caseId })),
        React.createElement("br", null),
        React.createElement(Button, { onClick: createTribunalCase, loading: loading }, lang.tribunal.createTribunalCase)));
};
export default AndreFogedsager;
//# sourceMappingURL=AndreFogedsager.js.map